import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { clearSiteGroupStore } from 'reducers/siteGroup/reducer'
import SiteGroupList from './SiteGroupList'
import SiteGroupForm from './SiteGroupForm'

function SiteGroup(props) {
  const {
    match: {
      params: { id },
    },
    clearSiteGroupStore,
  } = props
  const SiteGroupContent = id ? SiteGroupForm : SiteGroupList

  useEffect(
    () => () => {
      clearSiteGroupStore()
    },
    [],
  )

  return (
    <div className="content">
      <SiteGroupContent {...props} />
    </div>
  )
}

SiteGroup.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  clearSiteGroupStore: PropTypes.func.isRequired,
}

export default connect(null, {
  clearSiteGroupStore,
})(SiteGroup)
